import { render, staticRenderFns } from "./CodeEditBtn.vue?vue&type=template&id=566d1ff6"
import script from "./CodeEditBtn.vue?vue&type=script&lang=js"
export * from "./CodeEditBtn.vue?vue&type=script&lang=js"
import style0 from "./CodeEditBtn.vue?vue&type=style&index=0&id=566d1ff6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports